import { render, staticRenderFns } from "./attachedDocView.vue?vue&type=template&id=138e0e30&scoped=true&"
import script from "./attachedDocView.vue?vue&type=script&lang=js&"
export * from "./attachedDocView.vue?vue&type=script&lang=js&"
import style0 from "./attachedDocView.vue?vue&type=style&index=0&id=138e0e30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138e0e30",
  null
  
)

export default component.exports